import { Component } from '@theme/component';
import { ZoomMediaSelectedEvent } from '@theme/events';
import { DialogCloseEvent } from '@theme/dialog';

export class ZoomDialog extends Component {
  requiredRefs = ['dialog', 'media', 'thumbnails'];
  index = 0;
  connectedCallback() {
    super.connectedCallback();
    this.track = this.querySelector('.dialog-zoomed-gallery');
    this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.track?.removeEventListener('scroll', this.handleScroll);
    cancelAnimationFrame(this.frame);
  }
  open(index, event) {
    event?.preventDefault();
    if (this.refs.dialog.open) return;
    this.opener = document.activeElement;
    this.refs.dialog.showModal();
    this.selectThumbnail(index, { behavior: 'instant' });
  }
  close() { this.closeDialog(); }
  closeDialog() {
    this.querySelectorAll('video').forEach(video => video.pause());
    this.refs.dialog.close();
    window.dispatchEvent(new DialogCloseEvent());
    this.opener?.focus({ preventScroll: true });
  }
  handleKeyDown(event) {
    if (event.key === 'Escape') { event.preventDefault(); this.close(); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); this.previous(); }
    if (event.key === 'ArrowRight') { event.preventDefault(); this.next(); }
  }
  previous() { this.selectThumbnail((this.index - 1 + this.refs.media.length) % this.refs.media.length); }
  next() { this.selectThumbnail((this.index + 1) % this.refs.media.length); }
  handleThumbnailClick(index) { this.selectThumbnail(index); }
  handleThumbnailPointerEnter(index) { this.loadHighResolutionImage(this.refs.media[index]); }
  selectThumbnail(index, options = { behavior: 'smooth' }) {
    const media = this.refs.media[index];
    if (!media || !this.track) return;
    this.index = Number(index);
    this.track.scrollTo({ left: media.offsetLeft - this.refs.media[0].offsetLeft, behavior: options.behavior });
    this.updateSelection();
  }
  handleScroll = () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      const first = this.refs.media[0];
      this.index = this.refs.media.reduce((closest, media, i, all) =>
        Math.abs(media.offsetLeft - first.offsetLeft - this.track.scrollLeft) < Math.abs(all[closest].offsetLeft - first.offsetLeft - this.track.scrollLeft) ? i : closest, 0);
      this.updateSelection();
    });
  };
  updateSelection() {
    [...this.refs.thumbnails.querySelectorAll('button')].forEach((button, i) => button.setAttribute('aria-selected', String(i === this.index)));
    this.loadHighResolutionImage(this.refs.media[this.index]);
    this.refs.media.forEach((media, i) => { if (i !== this.index) media.querySelectorAll('video').forEach(video => video.pause()); });
    this.dispatchEvent(new ZoomMediaSelectedEvent(this.index));
  }
  loadHighResolutionImage(media) {
    const image = media?.querySelector('img.product-media__image');
    const source = image?.getAttribute('data_max_resolution');
    if (!source || image.dataset.rfHighResolution) return;
    image.dataset.rfHighResolution = 'true';
    const preload = new Image();
    preload.onload = () => { image.removeAttribute('srcset'); image.src = source; };
    preload.src = source;
  }
}
if (!customElements.get('zoom-dialog')) customElements.define('zoom-dialog', ZoomDialog);
